import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user.service';
import { passwordStrengthValidator } from 'src/app/shared/validators/password-strength.validator';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent {
  passwordForm!: FormGroup;

  passValue: string = '';


  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {


    this.passwordForm = this.formBuilder.group({
      password: ['', [passwordStrengthValidator()]],
      confirmPassword: ['']
    }, { validator: this.passwordMatchValidator });

    this.passwordForm.patchValue(data);
  }

  get passwordStrength() {
    const password = this.passwordForm.get('password')?.value;
    if (password) {
      return this.userService.calculateStrength(password);
    }
    return 0;
  }


  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      formGroup.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    } else {
      formGroup.get('confirmPassword')?.setErrors(null);
    }
  }

  onPasswordInput(event: Event){
    const pass = event.target as HTMLInputElement
    this.passValue = pass.value;
  }

  onSubmit() {
    if (this.passwordForm.valid) {
      const { password } = this.passwordForm.value;
      this.dialogRef.close({ password });
    }
  }

}
